<template>
  <div>
    <div class="py-5 flex flex-row flex-wrap selector justify-center">
      <div class="flex-initial section">
        <UserScore @click="selectScore(1)" :active="isSelected(1)">1</UserScore>
        <UserScore @click="selectScore(2)" :active="isSelected(2)">2</UserScore>
        <UserScore @click="selectScore(3)" :active="isSelected(3)">3</UserScore>
        <UserScore @click="selectScore(4)" :active="isSelected(4)">4</UserScore>
        <UserScore @click="selectScore(5)" :active="isSelected(5)">5</UserScore>
      </div>
      <div class="flex-initial section">
        <UserScore @click="selectScore(6)" :active="isSelected(6)">6</UserScore>
        <UserScore @click="selectScore(7)" :active="isSelected(7)">7</UserScore>
        <UserScore @click="selectScore(8)" :active="isSelected(8)">8</UserScore>
        <UserScore @click="selectScore(9)" :active="isSelected(9)">9</UserScore>
        <UserScore @click="selectScore(10)" :active="isSelected(10)">10</UserScore>
      </div>
      <br/>
    </div>
    <div v-if="legendMax && legendMin" class="hidden lg:flex pb-10 flex flex-row justify-between legend">
      <div class="flex-grow">{{ legendMin }}</div>
      <div class="flex-grow" style="text-align: right">{{ legendMax }}</div>
    </div>
  </div>
</template>

<script>
import UserScore from '@/components/UserScore'

export default {
  name: 'ScoreSelector',
  components: { UserScore },
  props: {
    modelValue: {
      default: null
    },
    legendMin: {
      default: null
    },
    legendMax: {
      default: null
    }
  },
  methods: {
    isSelected (value) {
      return value == this.modelValue
    },
    selectScore (score) {
      this.$emit('update:modelValue', score)
      this.$emit('change', score)
    }
  }
}
</script>

<style scoped>
.section {

}
.legend {
  margin: auto;
  max-width: 790px;
}
.legend div{
  font-weight: 600;
  font-size: 0.9rem;
  max-width: 130px;
}

</style>
